import React from 'react';
import Layout from '../../components/UI/Layout/Layout';
import List from '../../components/Entity/AgentCRM/List/List';

const AgentCRMPage = () => {
  return (
    <Layout fullwidth={0}>
      <List />
    </Layout>
  );
};

export default AgentCRMPage;
